module.exports = __webpack_public_path__ + "img/menu-icon.2e84eb90.svg";